import type { AxiosInstance, AxiosRequestConfig } from 'axios';
import axios from 'axios';
import type { ActiveInterceptorsRecord, ApiClientProps, ApiMiddleware, ApiResponse } from '../types';

export class AxiosWrapper {
    protected axiosInstance: AxiosInstance | null = null;
    private activeInterceptors: Record<string, ActiveInterceptorsRecord> = {};

    public static build(baseUrl: string, name: string): AxiosWrapper {
        return new AxiosWrapper({
            baseUrl,
            name,
        });
    }

    private constructor({ baseUrl, name }: ApiClientProps) {
        const axiosConfig: AxiosRequestConfig & { name: string } = {
            validateStatus: (status: number) => status === 200 || status === 204,
            headers: {
                'Content-Type': 'application/json',
            },
            baseURL: baseUrl,
            name,
        };

        this.axiosInstance = axios.create(axiosConfig);
        this.activeInterceptors = {};
    }

    public request<T>(requestConfig: AxiosRequestConfig): Promise<ApiResponse<T>> {
        return (this.axiosInstance as AxiosInstance).request(requestConfig);
    }

    public addMiddleware(middleware: ApiMiddleware): void {
        const { requestInterceptor, responseInterceptor, errorResponseHandler } = middleware;

        const interceptors = (this.axiosInstance as AxiosInstance).interceptors;
        const middlewareId = middleware.constructor.name;

        if (requestInterceptor) {
            this.activeInterceptors[middlewareId] = {
                ...this.activeInterceptors[middlewareId],
                requestInterceptorId: interceptors.request.use(requestInterceptor.bind(middleware)),
            };
        }
        if (responseInterceptor) {
            this.activeInterceptors[middlewareId] = {
                ...this.activeInterceptors[middlewareId],
                responseInterceptorId: interceptors.response.use(
                    responseInterceptor.bind(middleware),
                    errorResponseHandler && errorResponseHandler.bind(middleware),
                ),
            };
        }
    }
}
